//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'WellsDVT',
  data() {
    return {
      form:{
        Tumoractivestage:'0',
        Paralysis:'0',
        stayinbed:'0',
        deepveins:'0',
        edema:'0',
        lowerleg:'0',
        pittededema:'0',
        unilateral:'0',
        DVTorPE:'0',
        alternative:'0',
      },
      hasScore:false,
      disabled:false,
      descTxt:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.Tumoractivestage + form.Paralysis + form.stayinbed + form.deepveins + form.edema + form.lowerleg + form.pittededema + form.unilateral + form.DVTorPE + form.alternative * (-2)
      self.hasScore = true
      if (result>= 2) {
        self.descTxt = 'DVT高危'
      } else if(result<2) {
        self.descTxt = 'DVT低危'
      } else {
        self.descTxt = ''
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/WellsDVT.vue